<template>
  <div class="error-no-access-page">
    <div class="inner">
      <img src="~@/assets/logo.svg" class="logo" />
      <img src="~@/assets/icons/icon-auth.svg" class="logo-auth" />
      <h1 class="title">{{ $t("errorpage.noaccess.title") }}</h1>
      <p class="message">{{ $t("errorpage.noaccess.description") }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PErrorNoAccess"
};
</script>

<style lang="scss" scoped>
@import "../styles/variables";
.error-no-access-page {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #003a6d;
  text-align: center;
  .inner {
    position: relative;
    background: #fff;
    transition: all 0.3s 0.1s;
    margin: auto;
    max-width: 100%;
    width: 590px;
    padding: 40px 0 0 0;
    img {
      width: 160px;
    }
    .title {
      margin-top: 30px;
      margin-bottom: 15px;
      font-size: 24px;
      letter-spacing: 0.8px;
    }
    .message {
      margin-bottom: 100px;
      font-size: 16px;
      max-width: 335px;
      margin-left: auto;
      margin-right: auto;
    }
    .logo-auth {
      margin: 60px auto 0 auto;
      display: block;
      width: 80px;
    }
  }
}
</style>
